/**
 * Breakpoint constants for responsive design
 */
export const BREAKPOINT_COMPACT = 600;
export const BREAKPOINT_SMALL = 700;
export const BREAKPOINT_MEDIUM = 840;
export const BREAKPOINT_EXPANDED = 1200;
export const BREAKPOINT_LARGE = 1600;
